<template>
    <three-column-grid-section
        class="three-column-grid-section-module"
        :title="attributes.threeColumnGridSection_title"
        :columns="columns"
        :background-variant="attributes.threeColumnGridSection_background_variant"
        :grid-type="attributes.threeColumnGridSection_grid_type"
    />
</template>

<script>
    import ThreeColumnGridSection from '../../../organisms/ThreeColumnGridSection/ThreeColumnGridSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'three-column-grid-section-module',

        components: { ThreeColumnGridSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the columns for the ThreeColumnGridSection component.
             *
             * @returns {Array<{image: {src: string|undefined|null, alt: string|undefined|null}, text: string}>}
             */
            columns() {
                return [
                    {
                        image: formatMediaObject.call(this, this.attributes.threeColumnGridSection_column_1_image),
                        text: this.attributes.threeColumnGridSection_column_1_text,
                    },
                    {
                        image: formatMediaObject.call(this, this.attributes.threeColumnGridSection_column_2_image),
                        text: this.attributes.threeColumnGridSection_column_2_text,
                    },
                    {
                        image: formatMediaObject.call(this, this.attributes.threeColumnGridSection_column_3_image),
                        text: this.attributes.threeColumnGridSection_column_3_text,
                    },
                ].filter(({ text }) => text);
            },
        },
    };
</script>
